// extracted by mini-css-extract-plugin
export var changeIcon = "_71-4";
export var container = "_71-0";
export var divider = "_71-7";
export var externalLinkIcon = "_71-1";
export var green = "_71-5";
export var helpCircleIcon = "_71-3";
export var iconButton = "_71-2";
export var red = "_71-6";